const _excluded = ["onComplete", "imageValidator", "thumbnailComponent"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from 'react';
import { BlobContainerUpload } from '../BlobContainerUpload';
import { jsx as _jsx } from "react/jsx-runtime";
const readFileAsDataURL = file => {
  return new Promise((resolve, reject) => {
    let reader = new FileReader();
    reader.onload = () => {
      resolve(reader.result);
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
};
const readImage = src => {
  return new Promise((resolve, reject) => {
    let img = new Image();
    img.onload = () => resolve(img);
    img.onerror = reject;
    img.src = src;
  });
};
const defaultImageValidator = img => {
  if (img.imgSize > 71000000) {
    return {
      valid: false,
      errors: "width x height should be less than 71000000. Currently ".concat(img.width, " x ").concat(img.height, " = ").concat(img.imgSize)
    };
  }
  if (img.width < 600 || img.height < 600) {
    return {
      valid: false,
      errors: "both width and height should be be 600px or greater. Current dimensions are ".concat(img.width, " x ").concat(img.height)
    };
  }
  if (img.fileName.indexOf('&') > -1) {
    return {
      valid: false,
      errors: "file name should not contain \"&\""
    };
  }
  return {
    valid: true
  };
};
export function BlobContainerImageUpload(props) {
  const {
      onComplete,
      imageValidator = defaultImageValidator,
      thumbnailComponent
    } = props,
    other = _objectWithoutProperties(props, _excluded);
  const [candidateImages, setCandidateImages] = React.useState([]);
  const processAndValidate = async file => {
    try {
      const buffer = await readFileAsDataURL(file);
      const img = await readImage(buffer);
      const uploadedImage = {
        url: '',
        size: file.size,
        width: img.width,
        height: img.height,
        ratio: img.width / img.height,
        imgSize: img.width * img.height,
        fileName: file.name
      };
      let state = {
        valid: true
      };
      if (imageValidator) {
        state = imageValidator(uploadedImage);
      }
      if (state.valid) {
        candidateImages.push(uploadedImage);
        setCandidateImages(candidateImages);
      }
      return state;
    } catch (error) {
      return {
        valid: false,
        errors: 'error processing file, check if valid image'
      };
    }
  };
  const handleComplete = uploads => {
    if (onComplete) {
      const uploadedImages = candidateImages.map((img, i) => {
        img.url = uploads[i].url;
        return img;
      });
      onComplete(uploadedImages);
    }
  };
  return /*#__PURE__*/_jsx(BlobContainerUpload, _objectSpread({
    accept: 'image/png, image/jpeg',
    onComplete: handleComplete,
    fileValidator: processAndValidate,
    fileCompleteIcon: _ref => {
      let {
        uploaded
      } = _ref;
      if (!thumbnailComponent) {
        return null;
      }
      let image = candidateImages.find(img => img.fileName === uploaded.file.name);
      if (image) {
        image.url = uploaded.url.split('?')[0];
      }
      return thumbnailComponent({
        image
      });
    }
  }, other));
}